import { useState, useEffect } from "react"
import Sheet from 'react-modal-sheet';

export default function DashboardSortStatusModal(
    { 
        isDashboardSortStatusModalOpen,
        onDashboardSortStatusSaveClick,
        onDashboardSortStatusModalDismiss,
        initialStatus
    }
) {

    const [isSortAllowed, setIsSortAllowed] = useState(initialStatus)

    useEffect(() => {
        setIsSortAllowed(initialStatus)
    }, [initialStatus])

    function onStatusChange(status) {
        console.log(`onStatusChange ${status}`)
        setIsSortAllowed(status)
    }

    return <Sheet
     isOpen={isDashboardSortStatusModalOpen} onClose={() => {onDashboardSortStatusModalDismiss()}} onOpenEnd={() => {}} detent="conten-height"
     >
        <Sheet.Container>
        <Sheet.Header />
        <Sheet.Content className="bg-base-300">
        <Sheet.Scroller draggableAt="both">
        <div className="p-4 h-full">
        <div className="pb-8 px-4">
            <div className="font-bold text-lg pb-2 flex items-center font-titan">
                <span>Show sort button</span>
            </div>
            <div className="flex flex-col w-full gap-2">
                <div className="form-control w-52">
                    <label className="label cursor-pointer">
                    <span className="label-text text-lg">
                        {isSortAllowed ? "Yes" : "No"}
                    </span>
                    <input type="checkbox" className="toggle toggle-lg toggle-success" checked={isSortAllowed} onChange={(e) => {onStatusChange(e.target.checked)}}/>
                    </label>
                </div>
            </div>
        </div>
        <div className="modal-action bg-base-100 w-full px-4 py-4">
            <button className="btn btn-success text-success-content mr-2 normal-case" onClick={
                () => {
                    onDashboardSortStatusSaveClick(isSortAllowed)
                }
                } >
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path className="stroke-success-content" d="M8 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H9M8 20V14C8 13.4477 8.44772 13 9 13H15C15.5523 13 16 13.4477 16 14V20M8 20H16M16 20H18C19.1046 20 20 19.1046 20 18V8.82843C20 8.29799 19.7893 7.78929 19.4142 7.41421L16.5858 4.58579C16.2107 4.21071 15.702 4 15.1716 4H15M15 4V7C15 7.55228 14.5523 8 14 8H10C9.44772 8 9 7.55228 9 7V4M15 4H9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>    
                Save
            </button>

            <button className="btn btn-circle btn-soft" onClick={
                    () => {
                        onDashboardSortStatusModalDismiss()
                    }
                    }>
                <svg className="fill-base-content w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z"/></svg>
            </button>
        </div>
        </div>
        </Sheet.Scroller>
        </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={(_) => {
            onDashboardSortStatusModalDismiss()
        }}/>
    </Sheet>
}